<template>
	<v-tour
		name="tour"
		:options="tour_options" 
		:steps="steps"
		:callbacks="tour_callbacks"
	/>
</template>

<script>
import Api from "@/lib/Api";
import router from "@/router/index.js";

export default {
    name: "Tour",

    props: {
        tour: {
            type: String,
            require: true,
        },
        steps: {
            type: Array,
            require: true,
        },
        callbackOnFinish: {
            type: Boolean,
            require: false,
            default: false,
        },
    },

    data: function() {
        let callbacks = {};
        let labels = {};
        if (this.callbackOnFinish) {
            callbacks = {
                onSkip: this.cancelTour,
                onFinish: this.nextTour,
            };
			labels = {
				buttonSkip: 'Cancelar',
				buttonPrevious: '< Anterior',
				buttonNext: 'Próxima >',
				buttonStop: 'Próxima seção',
			};
        } else {
            callbacks = {
                onSkip: this.cancelTour,
            };
			labels = {
				buttonSkip: 'Cancelar',
				buttonPrevious: '< Anterior',
				buttonNext: 'Próxima >',
				buttonStop: 'Finalizar',
			};
        }

        return {
            tour_list: this.$api.user.tour ? this.$api.user.tour.split(",") : [],
            tour_options: {
                useKeyboardNavigation: true,
                labels: labels,
            },
            tour_callbacks: callbacks,
        }
    },

    methods: {
        editTour: async function() {
            // Inicia as variáveis necessárias
            let index = this.tour_list.findIndex(element => element == this.tour);
            if(index != -1) {
                this.tour_list.splice(index, 1);
                this.$api.user.tour = this.tour_list.length > 0 ? this.tour_list.join(",") : null;
            } else {
                this.tour_list.push(this.tour);
                this.$api.user.tour = this.tour_list.length > 0 ? this.tour_list.join(",") : null;
            }
			
			let form = {
				id: this.$api.user.id,
				tour: this.$api.user.tour,
			};
			let result = null;

			// Requisita a remoção
			try {
				result = await Api.post("user/update-tour", form);
			} catch (ex) {
				console.log(ex);
				this.$notification.error("Não foi possível concluir o salvamento da escolha desejada.");
				return;
			}

			// Verifica o resultado
			if(result) {
				// Verifica se houve erro
				if(result.error) {
					this.$notification.error(result.data);
					return;
				} else {
					this.updateTour();
					this.setTour();
					return;
				}
			} else {
				this.$notification.error("Não foi possível concluir o salvamento da escolha desejada.");
				return;
			}
		},

        updateTour: function() {
            this.tour_list = this.$api.user.tour ? this.$api.user.tour.split(",") : [];
        },

		setTour: function() {
            // Atuliza os passos de exibição do tour
            if (this.tour_list.includes(this.tour)) this.$tours['tour'].start();
            else this.$tours['tour'].stop();
        },

		cancelTour: async function() {
			// Inicia as variáveis necessárias
			let index = this.tour_list.findIndex(element => element == this.tour);
			if(index != -1) {
				this.tour_list.splice(index, 1);
				this.$api.user.tour = this.tour_list.length > 0 ? this.tour_list.join(",") : null;
			}
			
			let form = {
				id: this.$api.user.id,
				tour: this.$api.user.tour,
			};
			let result = null;

			// Requisita a remoção
			try {
				result = await Api.post("user/update-tour", form);
			} catch (ex) {
				console.log(ex);
				this.$notification.error("Não foi possível concluir o salvamento da escolha desejada.");
				return;
			}

			// Verifica o resultado
			if(result) {
				// Verifica se houve erro
				if(result.error) {
					this.$notification.error(result.data);
					return;
				} else {
					this.updateTour();
					this.setTour();
					return;
				}
			} else {
				this.$notification.error("Não foi possível concluir o salvamento da escolha desejada.");
				return;
			}
        },

		nextTour: async function() {
			// Inicia as variáveis necessárias
			let index = this.tour_list.findIndex(element => element == this.tour);
			if(index != -1) {
				this.tour_list.splice(index, 1);
				this.$api.user.tour = this.tour_list.length > 0 ? this.tour_list.join(",") : null;
			}
			
			let form = {
				id: this.$api.user.id,
				tour: this.$api.user.tour,
			};
			let result = null;

			// Requisita a remoção
			try {
				result = await Api.post("user/update-tour", form);
			} catch (ex) {
				console.log(ex);
				this.$notification.error("Não foi possível concluir o salvamento da escolha desejada.");
				return;
			}

			// Verifica o resultado
			if(result) {
				// Verifica se houve erro
				if(result.error) {
					this.$notification.error(result.data);
					return;
				} else {
					this.updateTour();
					this.setTour();
					this.setNextTour();
				}
			} else {
				this.$notification.error("Não foi possível concluir o salvamento da escolha desejada.");
				return;
			}
        },

		setNextTour: function() {
			switch (this.tour) {
				case "Home":
					if (this.$api.user.is_admin) {
						this.editNextTour("Customer");
						router.push({ name: 'Customer' });
					} else {
						if (this.$permission.hasAreaPermission("Customer")) {
							this.editNextTour("Customer");
							router.push({ name: 'Customer' });
						} else if (this.$permission.hasAreaPermission("DistributionCenter")) {
							this.editNextTour("DistributionCenter");
							router.push({ name: 'DistributionCenter' });
						} else if (this.$permission.hasAreaPermission("Driver")) {
							this.editNextTour("Driver");
							router.push({ name: 'Driver' });
						} else if (this.$permission.hasAreaPermission("Vehicle")) {
							this.editNextTour("Vehicle");
							router.push({ name: 'Vehicle' });
						} else if (this.$permission.hasAreaPermission("Delivery")) {
							this.editNextTour("Delivery");
							router.push({ name: 'Delivery' });
						} else if (this.$permission.hasAreaPermission("DeliveryRouting")) {
							this.editNextTour("DeliveryRouting");
							router.push({ name: 'Routing' });
						} else if (this.$permission.hasAreaPermission("Tracking")) {
							this.editNextTour("Tracking");
							router.push({ name: 'Tracking' });
						} else if (this.$permission.hasAreaPermission("Report")) {
							this.editNextTour("Report");
							router.push({ name: 'Report' });
						} else if (this.$permission.hasAreaPermission("Config")) {
							this.editNextTour("Config");
							router.push({ name: 'Config' });
						}
					}
					break;
					case "Customer":
						if (this.$api.user.is_admin) {
							this.editNextTour("DistributionCenter");
							router.push({ name: 'DistributionCenter' });
						} else {
							if (this.$permission.hasAreaPermission("DistributionCenter")) {
								this.editNextTour("DistributionCenter");
								router.push({ name: 'DistributionCenter' });
							} else if (this.$permission.hasAreaPermission("Driver")) {
								this.editNextTour("Driver");
								router.push({ name: 'Driver' });
							} else if (this.$permission.hasAreaPermission("Vehicle")) {
								this.editNextTour("Vehicle");
								router.push({ name: 'Vehicle' });
							} else if (this.$permission.hasAreaPermission("Delivery")) {
								this.editNextTour("Delivery");
								router.push({ name: 'Delivery' });
							} else if (this.$permission.hasAreaPermission("DeliveryRouting")) {
								this.editNextTour("DeliveryRouting");
								router.push({ name: 'Routing' });
							} else if (this.$permission.hasAreaPermission("Tracking")) {
								this.editNextTour("Tracking");
								router.push({ name: 'Tracking' });
							} else if (this.$permission.hasAreaPermission("Report")) {
								this.editNextTour("Report");
								router.push({ name: 'Report' });
							} else if (this.$permission.hasAreaPermission("Config")) {
								this.editNextTour("Config");
								router.push({ name: 'Config' });
							}
						}
						break;
					case "DistributionCenter":
						if (this.$api.user.is_admin) {
							this.editNextTour("Driver");
							router.push({ name: 'Driver' });
						} else {
							if (this.$permission.hasAreaPermission("Driver")) {
								this.editNextTour("Driver");
								router.push({ name: 'Driver' });
							} else if (this.$permission.hasAreaPermission("Vehicle")) {
								this.editNextTour("Vehicle");
								router.push({ name: 'Vehicle' });
							} else if (this.$permission.hasAreaPermission("Delivery")) {
								this.editNextTour("Delivery");
								router.push({ name: 'Delivery' });
							} else if (this.$permission.hasAreaPermission("DeliveryRouting")) {
								this.editNextTour("DeliveryRouting");
								router.push({ name: 'Routing' });
							} else if (this.$permission.hasAreaPermission("Tracking")) {
								this.editNextTour("Tracking");
								router.push({ name: 'Tracking' });
							} else if (this.$permission.hasAreaPermission("Report")) {
								this.editNextTour("Report");
								router.push({ name: 'Report' });
							} else if (this.$permission.hasAreaPermission("Config")) {
								this.editNextTour("Config");
								router.push({ name: 'Config' });
							}
						}
						break;
					case "Driver":
						if (this.$api.user.is_admin) {
							this.editNextTour("Vehicle");
							router.push({ name: 'Vehicle' });
						} else {
							if (this.$permission.hasAreaPermission("Vehicle")) {
								this.editNextTour("Vehicle");
								router.push({ name: 'Vehicle' });
							} else if (this.$permission.hasAreaPermission("Delivery")) {
								this.editNextTour("Delivery");
								router.push({ name: 'Delivery' });
							} else if (this.$permission.hasAreaPermission("DeliveryRouting")) {
								this.editNextTour("DeliveryRouting");
								router.push({ name: 'Routing' });
							} else if (this.$permission.hasAreaPermission("Tracking")) {
								this.editNextTour("Tracking");
								router.push({ name: 'Tracking' });
							} else if (this.$permission.hasAreaPermission("Report")) {
								this.editNextTour("Report");
								router.push({ name: 'Report' });
							} else if (this.$permission.hasAreaPermission("Config")) {
								this.editNextTour("Config");
								router.push({ name: 'Config' });
							}
						}
						break;
					case "Vehicle":
						if (this.$api.user.is_admin) {
							this.editNextTour("Delivery");
							router.push({ name: 'Delivery' });
						} else {
							if (this.$permission.hasAreaPermission("Delivery")) {
								this.editNextTour("Delivery");
								router.push({ name: 'Delivery' });
							} else if (this.$permission.hasAreaPermission("DeliveryRouting")) {
								this.editNextTour("DeliveryRouting");
								router.push({ name: 'Routing' });
							} else if (this.$permission.hasAreaPermission("Tracking")) {
								this.editNextTour("Tracking");
								router.push({ name: 'Tracking' });
							} else if (this.$permission.hasAreaPermission("Report")) {
								this.editNextTour("Report");
								router.push({ name: 'Report' });
							} else if (this.$permission.hasAreaPermission("Config")) {
								this.editNextTour("Config");
								router.push({ name: 'Config' });
							}
						}
						break;
					case "Delivery":
						if (this.$api.user.is_admin) {
							this.editNextTour("DeliveryRouting");
							router.push({ name: 'Routing' });
						} else {
							if (this.$permission.hasAreaPermission("DeliveryRouting")) {
								this.editNextTour("DeliveryRouting");
								router.push({ name: 'Routing' });
							} else if (this.$permission.hasAreaPermission("Tracking")) {
								this.editNextTour("Tracking");
								router.push({ name: 'Tracking' });
							} else if (this.$permission.hasAreaPermission("Report")) {
								this.editNextTour("Report");
								router.push({ name: 'Report' });
							} else if (this.$permission.hasAreaPermission("Config")) {
								this.editNextTour("Config");
								router.push({ name: 'Config' });
							}
						}
						break;
					case "DeliveryRouting":
						if (this.$api.user.is_admin) {
							this.editNextTour("Tracking");
							router.push({ name: 'Tracking' });
						} else {
							if (this.$permission.hasAreaPermission("Tracking")) {
								this.editNextTour("Tracking");
								router.push({ name: 'Tracking' });
							} else if (this.$permission.hasAreaPermission("Report")) {
								this.editNextTour("Report");
								router.push({ name: 'Report' });
							} else if (this.$permission.hasAreaPermission("Config")) {
								this.editNextTour("Config");
								router.push({ name: 'Config' });
							}
						}
						break;
					case "Tracking":
						if (this.$api.user.is_admin) {
							this.editNextTour("Report");
							router.push({ name: 'Report' });
						} else {
							if (this.$permission.hasAreaPermission("Report")) {
								this.editNextTour("Report");
								router.push({ name: 'Report' });
							} else if (this.$permission.hasAreaPermission("Config")) {
								this.editNextTour("Config");
								router.push({ name: 'Config' });
							}
						}
						break;
					case "Report":
						if (this.$api.user.is_admin) {
							this.editNextTour("Config");
							router.push({ name: 'Config' });
						} else {
							if (this.$permission.hasAreaPermission("Config")) {
								this.editNextTour("Config");
								router.push({ name: 'Config' });
							}
						}
						break;
					case "Config":
						router.push({ name: 'Home' });
						break;
				default:
					router.push({ name: 'Home' });
					break;
			}
        },

		editNextTour: function(value) {
			// Inicia as variáveis necessárias
			let index = this.tour_list.findIndex(element => element == value);
			if(index == -1) {
				this.tour_list.push(value);
				this.$api.user.tour = this.tour_list.length > 0 ? this.tour_list.join(",") : null;
			}
		},
    }
}
</script>

<style>
.v-tour__target--highlighted {
	box-shadow: 0 0 0 99999px rgba(0,0,0,.4) !important;
}

.v-step {
	background: none !important;
	color: #333 !important;
	border-radius: 4px !important;
	border: 1px solid #f0f0f0;
	background-color: #fff !important;
}

.v-step__header {
	border-top-left-radius: 4px !important;
	border-top-right-radius: 4px !important;
	border: none !important;
	border-bottom: 1px solid #f0f0f0 !important;
	background-color: #fff !important;
	font-weight: bold !important;
	font-size: 15px !important;
	color: #2c3e50 !important;
}

.v-step__content {
	text-align: left !important;
	font-size: 13px !important;
}

.v-step__button {
	border: none !important;
	font-size: 10px !important;
	padding: 8px !important;
	line-height: 0 !important;
}

.v-step__button-skip {
	background: #d9d9d9 !important;
	color: #595959 !important;
}

.v-step__button-previous {
	border: 1px solid #000 !important;
	background: #fff !important;
	color: #000 !important;
}

.v-step__button-next {
	background: black !important;
	color: #fff !important;
}

.v-step__button-stop {
	background: #000 !important;
	color: #fff !important;
}

.v-step__arrow--dark::before {
	background: #fff !important;
}
</style>
